import React, { Component } from "react";
import "./Skills.css";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import { Fade } from "react-awesome-reveal";
import DataScienceImg from "./DataScienceImg";
import FullStackImg from "./FullStackImg";
import CloudInfraImg from "./CloudInfraImg";
import DesignImg from "./DesignImg";
import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type State = {
  redirect: boolean,
}

type Props = {
  theme: ThemeProps,
}

function GetSkillSvg(props:any) {
  if (props.fileName === "DataScienceImg")
    return <DataScienceImg theme={props.theme} />;
  else if (props.fileName === "FullStackImg")
    return <FullStackImg theme={props.theme} />;
  else if (props.fileName === "CloudInfraImg")
    return <CloudInfraImg theme={props.theme} />;
  return <DesignImg theme={props.theme} />;
}
export default function SkillSection({ theme }: Props) {
    //const theme = this.props.theme;
    const { t, i18n } = useTranslation();
    return (
      <div>
        {skills.data.map((skill) => {
          return (
            <div className="skills-main-div">
              <Fade direction="left" duration={2000} triggerOnce={true}>
                <div className="skills-image-div">
                  {/* <img
                    alt="Ashutosh is Analysing Data"
                    src={require(`../../assests/images/${skill.imagePath}`)}
                  ></img> */}
                  <GetSkillSvg fileName={skill.fileName} theme={theme} />
                </div>
              </Fade>

              <div className="skills-text-div">
                <Fade direction="right" duration={1000} triggerOnce={true}>
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {t(skill.title)}
                  </h1>
                </Fade>
                <Fade direction="right" duration={1500} triggerOnce={true}>
                 <SoftwareSkill logos={skill.softwareSkills} />
                </Fade>
                <Fade direction="right" duration={2000} triggerOnce={true}>
                  <div>
                    {skill.skills.map((skillSentence) => {
                      return (
                        <p
                          className="subTitle skills-text"
                          style={{ color: theme.secondaryText }}
                        >
                         {t(skillSentence)}
                        </p>
                      );
                    })}
                  </div>
                </Fade>
              </div>
            </div>
          );
        })}
      </div>
    );
}
